import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { FeatureFlagsRoot, initializeFeatureFlags } from './featureFlags';
import './styles.css';
import './standalone.css';
import { initializeAmplitudeSdk } from './utils/amplitudeUtils';
import { initializeWindowRuntimeEnv } from './runtimeEnv';
const mountedRoots = new WeakMap();
export function mount(container, options = {}) {
    initializeWindowRuntimeEnv();
    initializeAmplitudeSdk();
    initializeFeatureFlags();
    const existingRoot = mountedRoots.get(container);
    if (existingRoot) {
        existingRoot.unmount();
    }
    const root = createRoot(container);
    mountedRoots.set(container, root);
    root.render(_jsx(StrictMode, { children: _jsx(FeatureFlagsRoot, { children: _jsx(App, { appName: options.appName, basePath: options.basePath }) }) }));
    return {
        unmount: () => {
            root.unmount();
            mountedRoots.delete(container);
        },
    };
}
